
(() => {
    const storageKey = 'dl-navigation-collection';
    const titleStorageKey = `${storageKey}-title`;
    const collectionPrefix = '/collections/';
    const productPrefix = '/products/';

    function getPath(url) {
        try {
            return new URL(url, window.location.origin).pathname
                .replace(/\/+$/, '') || '/';
        } catch {
            return '';
        }
    }

    function isCollection(path) {
        return path.startsWith(collectionPrefix);
    }

    function isProduct(path) {
        return path.startsWith(productPrefix) || path.includes(`${productPrefix}`);
    }

    // Remember the collection when navigating to a product.
    document.addEventListener('click', (event) => {
        const link = event.target.closest('a[href]');

        if (!link) return;

        const currentPath = getPath(window.location.pathname);
        const targetPath = getPath(link.href);

        if (isCollection(currentPath) && isProduct(targetPath)) {
            const collectionTitle = document.querySelector('h1')?.textContent.trim();

            sessionStorage.setItem(storageKey, currentPath);
            sessionStorage.setItem(titleStorageKey, collectionTitle || '');
        } else if (!isProduct(targetPath)) {
            sessionStorage.removeItem(storageKey);
            sessionStorage.removeItem(titleStorageKey);
        }
    });

    function restoreCollectionMenu() {
        if (!isProduct(getPath(window.location.pathname))) return;

        const savedCollection = sessionStorage.getItem(storageKey);
        const savedCollectionTitle = sessionStorage.getItem(titleStorageKey);

        if (!savedCollection) return;

        // Update back link
        const backLink = document.querySelector('[data-product-back-link]');
        const backLinkText = document.querySelector('[data-product-back-link-text]');

        if (backLink) {
            backLink.href = savedCollection;
        }

        const backLinkWrapper = document.querySelector('.product-back-link-wrapper');

        if (backLinkText && savedCollectionTitle) {
            const label = backLinkText.dataset.backLabel;

            if (label) {
                backLinkText.textContent = label.replace(
                    '__COLLECTION__',
                    savedCollectionTitle
                );

                if (backLink) {
                    backLink.href = savedCollection;
                }

                if (backLinkWrapper) {
                    backLinkWrapper.hidden = false;
                }
            }
        }

        // Restore active collection in menu
        const links = document.querySelectorAll(
            '.menu__item a[href], .header__dropdown a[href]'
        );

        const matchingLink = Array.from(links).find((link) => {
            return getPath(link.href) === savedCollection;
        });

        if (!matchingLink) return;

        document.querySelectorAll(
            '.menu__item.main-menu--active, .navlink.main-menu--active'
        ).forEach((element) => {
            element.classList.remove('main-menu--active');
        });

        matchingLink.classList.add('main-menu--active');

        const topLevelItem = matchingLink.closest('.menu__item');

        if (topLevelItem) {
            topLevelItem.classList.add('main-menu--active');
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', restoreCollectionMenu);
    } else {
        restoreCollectionMenu();
    }
})();
